import ActionTypes from "core/actions/actionTypes";
import initialState from "./initialState";

export default function editReducer(state = initialState.edit, action: any) {
	switch (action.type) {

		case ActionTypes.EDIT_TOGGLE:

			// toggle the dialog
			return {...state, enabled: action.enabled};

		case ActionTypes.EDIT_PANEL_TOGGLE:

			// toggle the dialog
			return {...state, panelDialog: action.instance};

		case ActionTypes.EDIT_LAYOUT_TOGGLE:

			// toggle the layout edit
			return {...state, layout: action.enabled};

		case ActionTypes.EDIT_CHANGES_INCREMENT:

			return {...state, changes: state.changes + 1};

		case ActionTypes.CONFIG_LOAD_SUCCESS :

			return {...state, changes: 0};


		case ActionTypes.EDIT_ACTIVE_SET:

			return {...state, active: action.active };

		default:

			return state;

	}
}



// WEBPACK FOOTER //
// ./src/core/reducers/editReducer.ts